<app-form-group>
  <app-info class="formGroupLabel">
    <label>Defumigator company</label>
    <div class="tooltipContent">If you choose "Other" enter the company name in the "Defumigator company details" field</div>
  </app-info>
  <app-select id="defumigatorCompany" [optionsProvider]="defumigatorCompanies"
              dataKey="name"
              [(ngModel)]="fumigation().defumigatorCompany"
              required>
  </app-select>
</app-form-group>
@if (isOtherDefumigatorCompany()) {
  <app-form-group>
    <app-info class="formGroupLabel">
      <label>Defumigator company details</label>
      <div class="tooltipContent">Enter the defumigator company details</div>
    </app-info>
    <textarea id="defumigatorCompanyDetails"
              [(ngModel)]="fumigation().defumigatorCompanyDetails" rows="2" maxlength="256" class="form-control" required>
    </textarea>
  </app-form-group>
}
